import type { TenantBootstrapModel } from '@unified-lk/tenant-config'
import type { PresentationPhotoSource } from '../diagnostics/planPresentation'

export function buildStaffPhotoPreviewUrl(
  bootstrap: TenantBootstrapModel,
  thumbnailPath: string,
): string {
  const q = new URLSearchParams({ thumbnail_path: thumbnailPath })
  return `${bootstrap.apiBase}/staff/ai-presentations/photo-content?${q}`
}

/** Direct URL or staff proxy path (requires Authorization when fetched). */
export function resolvePhotoPreviewSrc(
  photo: PresentationPhotoSource,
  bootstrap: TenantBootstrapModel,
): string | null {
  if (photo.preview_url) return photo.preview_url
  if (photo.thumbnail_path) return buildStaffPhotoPreviewUrl(bootstrap, photo.thumbnail_path)
  return null
}

export function needsAuthedPreviewFetch(src: string, apiBase: string): boolean {
  return src.includes(`${apiBase}/staff/ai-presentations/photo-content`)
}
